import style from "./Modal.css";

const Modal = ({ headerText, onClose, children }) => {
  return (
    <div class={style.modalOverlay} onClick={onClose}>
      <div class={style.modalContent} onClick={(e) => e.stopPropagation()}>
        <h3 class={style.headerTitle}>{`${headerText}`}</h3>
        <div class={style.close} onClick={onClose} />
        {children}
      </div>
    </div>
  );
};

export { Modal };
